module.exports = __webpack_public_path__ + "img/NOYA_05.7e65b46d.jpg";